import React, { ReactNode, useMemo } from "react";
import { IWebsiteBuilderNodeDimensions, IWebsiteBuilderNodePosition } from "../../../../../nodes/websiteBuilderNode";

interface IElementViewPositionIndicator {
  type: "position";
  position: IWebsiteBuilderNodePosition;
}

interface IElementViewDimensionsIndicator {
  type: "dimensions";
  position: IWebsiteBuilderNodePosition;
  dimensions: IWebsiteBuilderNodeDimensions;
}

export type TElementViewIndicator = IElementViewPositionIndicator | IElementViewDimensionsIndicator;

interface IElementViewIndicatorProps {
  indicator: TElementViewIndicator;
}

const INDICATOR_HEIGHT = 25;
const INDICATOR_OFFSET = 3;

export function ElementViewIndicator(props: IElementViewIndicatorProps) {
  const { indicator } = props;

  const indicatorContent: ReactNode = useMemo(() => {
    let data: ReactNode = null;

    if (indicator?.type === "position" && indicator.position) {
      const roundedPosition: IWebsiteBuilderNodePosition = {
        x: Math.round(indicator.position.x),
        y: Math.round(indicator.position.y),
      };

      data = (
        <>
          ({roundedPosition.x}, {roundedPosition.y})
        </>
      );
    } else if (indicator?.type === "dimensions" && indicator.dimensions) {
      const roundedDimensions: IWebsiteBuilderNodeDimensions = {
        width: Math.round(indicator.dimensions.width),
        height: Math.round(indicator.dimensions.height),
      };

      data = (
        <>
          {roundedDimensions.width} x {roundedDimensions.height}
        </>
      );
    }

    return <div className="element-view-indicator-content">{data}</div>;
  }, [indicator]);

  if (!indicator) {
    return null;
  }

  const spaceOnTop = indicator.position?.y > INDICATOR_HEIGHT + INDICATOR_OFFSET;

  return (
    <div
      className="website-builder-element-view-indicator"
      style={{
        height: INDICATOR_HEIGHT,
        top: spaceOnTop ? "0" : "100%",
        transform: `translateY(
          ${spaceOnTop ? `calc(-100% - ${INDICATOR_OFFSET}px)` : `${INDICATOR_OFFSET}px`}
        )`,
      }}
    >
      {indicatorContent}
    </div>
  );
}
